import React from 'react';

const WebLoading: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  if (!isLoading) return null;
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: ` @keyframes spin { to { transform: rotate(360deg); } } `,
        }}
      />
      <div className="z-50 fixed inset-0 flex justify-center items-center bg-gradient-to-br from-gray-50 to-white">
        <div className="relative flex justify-center items-center">
          <div className="absolute bg-blue-400/25 blur-xl rounded-full w-28 h-28" />
          <div className="relative border-[6px] border-gray-200 border-t-blue-500 border-r-blue-400 border-b-transparent rounded-full w-24 h-24 animate-[spin_1s_linear_infinite]" />
          <img
            src={`${process.env.PUBLIC_URL || ''}/icons/icon128.png`}
            alt="Loading"
            className="absolute w-10 h-10 object-contain"
          />
        </div>
      </div>
    </>
  );
};

export default WebLoading;
